export default __webpack_public_path__ + "static/media/58.1c766795.png";